module.exports = __webpack_public_path__ + "879dec321d9c8be88b35c4a2019bd0b2.png";